import React, { useEffect, useState } from "react";
import { useOutletContext, useParams, useSearchParams } from "react-router-dom";
import {
  calcDisplayNo,
  getAllClassRecords,
  sortMonths,
} from "../../AppManager";
import AttendanceCard from "./AttendanceCard";
import EmptySearch from "../../components/EmptySearch";
import Pagination from "../../components/Pagination";

function AdminAttendance() {
  const { search, setShowSearch, setPreventRefetch } = useOutletContext();
  const [data, setData] = useState([]);
  const { Class } = useParams();
  const [attendanceFetch, setAttendanceFetch] = useState(false);
  const [searchParams] = useSearchParams();
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
  });

  useEffect(() => {
    let page = searchParams.get("page") || 1;
    page = parseInt(page);
    page = page > 0 ? page : 1;

    let limit = searchParams.get("limit") || 10;
    limit = parseInt(limit);
    limit = limit > 0 ? limit : 10;
    setPagination({ page, limit });
  }, [searchParams]);

  useEffect(() => {
    const width = 210;
    const height = 160;
    const pagePadMarginWidth = 20;
    const pagePadMarginHeight = 20;
    setPagination((old) => ({
      ...old,
      limit: calcDisplayNo(
        width,
        height,
        pagePadMarginWidth,
        pagePadMarginHeight
      ),
    }));
    window.addEventListener("resize", () => {
      setPagination((old) => ({
        ...old,
        limit: calcDisplayNo(
          width,
          height,
          pagePadMarginWidth,
          pagePadMarginHeight
        ),
      }));
    });

    return () => {
      window.removeEventListener("resize", () => {
        setPagination((old) => ({
          ...old,
          limit: calcDisplayNo(
            width,
            height,
            pagePadMarginWidth,
            pagePadMarginHeight
          ),
        }));
      });
    };
  }, []);

  useEffect(() => {
    getAllClassRecords(Class)
      .then((data) => {
        setData(data);
        setAttendanceFetch(true);
      })
      .catch((err) => err);
  }, [Class]);

  useEffect(() => {
    setShowSearch(true);
    setPreventRefetch(true);
  });

  const stripClass = data.map((dat) => {
    return dat.slice(0, dat.toLowerCase().indexOf(Class.toLowerCase()) - 1);
  });

  const toSort = stripClass.filter((dat) => dat !== "Current");
  const sorted = sortMonths(toSort);
  stripClass.includes("Current") && sorted.unshift("Current");

  document.title = `${Class} Attendance`;

  function AttendanceLoader() {
    return (
      <>
        <div
          className="loader-item"
          style={{
            width: "200px",
            height: "140px",
            background: "linear-gradient(to top right, #F4F6FF 0%, #FFF 100%)",
            backgroundSize: "200% 100%",
            boxShadow: "0 5px 8px rgba(0, 0, 0, 0.4)",
            borderRadius: "10px",
            margin: "10px 5px",
          }}
        ></div>
        <div
          className="loader-item"
          style={{
            width: "200px",
            height: "140px",
            background: "linear-gradient(to top right, #F4F6FF 0%, #FFF 100%)",
            backgroundSize: "200% 100%",
            boxShadow: "0 5px 8px rgba(0, 0, 0, 0.4)",
            borderRadius: "10px",
            margin: "10px 5px",
          }}
        ></div>
        <div
          className="loader-item"
          style={{
            width: "200px",
            height: "140px",
            background: "linear-gradient(to top right, #F4F6FF 0%, #FFF 100%)",
            backgroundSize: "200% 100%",
            boxShadow: "0 5px 8px rgba(0, 0, 0, 0.4)",
            borderRadius: "10px",
            margin: "10px 5px",
          }}
        ></div>
      </>
    );
  }

  const { page, limit } = pagination;
  const start = (page - 1) * limit;
  const end = start + limit;

  const classes = sorted
    .filter((dat) => dat.toLowerCase().indexOf(search.toLowerCase()) > -1)
    .slice(start, end)
    .map((dat) => <AttendanceCard key={dat} name={dat} Class={Class} />);

  return (
    <div className="overview-students">
      <h1 className="heading1" style={{ width: "100vw" }}>
        {Class} Attendance
      </h1>
      {attendanceFetch ? (
        classes.length === 0 ? (
          <EmptySearch message={"No Attendance Found"} />
        ) : (
          <>
            {classes}
            <Pagination
              limit={pagination.limit}
              currentPage={pagination.page}
              totalPages={Math.ceil(data.length / pagination.limit)}
            />
          </>
        )
      ) : (
        <AttendanceLoader />
      )}
    </div>
  );
}

export default AdminAttendance;
